import mgl from "mapbox-gl/dist/mapbox-gl";
import {LoadJsonFile, ListYearMonthWithStep} from "./Utility";
import createFeature from "geojson-vt/src/feature";

// Globals
var visPage = null;
var visConf = LoadJsonFile("VisData/VisConfig.json");
const MapApiKey = 'pk.eyJ1IjoiemN0enp5IiwiYSI6ImNrMHBrMjIyYTBrYTUzZHM4bDNlOHdvbnoifQ.aBNOdmnrTnY28EZ0AQpA3A';


// ------------- Page Init: Late -------------------
window.onload = function () {
    mgl.accessToken = MapApiKey;

    InitVisConfig();

    visPage = VisPage();
    visPage.init();

    visPage.mapWnd.map.on("load", function () {
        visPage.showDefaultScenario();
    });
}
//#1A9850, #91CF60, #D9EF8B, #FEE08B, #FC8D59, #D73027
function InitVisConfig() {
    var startMonth = visConf["StartMonth"];
    var endMonth = visConf["EndMonth"];
    var step = visConf["MonthStep"];

    visConf.MonthList = ListYearMonthWithStep(startMonth, endMonth, step);
    visConf.MapBoxStyle = 'mapbox://styles/mapbox/dark-v10';
    // mapbox://styles/mapbox/streets-v11
    // mapbox://styles/mapbox/dark-v10

    visConf.OutlineColor = "#000000";
    visConf.BlankColor = "#DDDDDD";
    visConf.Opacity = 1;
    visConf.GridOpacity = 1;
    visConf.ColorMap = [
        'interpolate',
        ['linear'],
        ['get', 'i'],
        0.0, "#1A9850",
        0.2, "#91CF60",
        0.4, "#D9EF8B",
        0.6, "#FEE08B",
        0.8, "#FC8D59",
        1.0, "#D73027"
    ];

    visConf.FillColorSetup = [
        "case",
        ["==", ['get', 'i'], -1], visConf.BlankColor,
        visConf.ColorMap
    ];
}

function PlayAnimation () {
    if (visPage.bOnPlay) {
        visPage.bnPlay.className = "fas fa-square";

        let iMonth = visPage.rngMonth.value;
        iMonth++;

        if (visPage.rngMonth.max < iMonth) {
            visPage.stopAnimation();
            return;
        }

        visPage.rngMonth.value = iMonth;
        visPage.lbMonth.textContent = visConf.MonthList[iMonth];

        // Update map
        visPage.mapWnd.repaint();

        setTimeout(PlayAnimation, 100);
    }
}


// --------------- Class ------------------

// Maintain Page UI
function VisPage() {
    var page = new Object();

    // fetch useful UI members
    page.rdDivn    = document.getElementById("rdDivn");
    page.rdGrid    = document.getElementById("rdGrid");
    page.selCntry  = document.getElementById("selCountry");
    page.rngMonth  = document.getElementById("rngMonth");
    page.lbMonth   = document.getElementById("lbMonth");
    page.detailSetup = document.getElementById("detailSetup");

    // Index Parameters
    page.rngAlpha = document.getElementById("alpha");
    page.nbAlpha  = document.getElementById("nbAlpha");
    page.rngBeta  = document.getElementById("beta");
    page.nbBeta   = document.getElementById("nbBeta");
    page.rngRho   = document.getElementById("rho");
    page.nbRho    = document.getElementById("nbRho");

    // Info Board
    page.infoName  = document.getElementById("infoName");
    page.infoPopu  = document.getElementById("infoPopu");
    page.infoBstn  = document.getElementById("infoBstn");
    page.infoImba  = document.getElementById("infoImba");
    page.infoBoard = document.getElementById("infoBoard");

    // Play Button
    page.bnPlay = document.getElementById("bnPlay");
    page.bOnPlay = false;

    page.mapWnd = null;
    page.scWorld = null;

    // Initialization -------------------------------
    page.initSelCountry = function () {
        for (var i = 0; i < visConf["CountryList"].length; i++) {
            var alpha3 = visConf["CountryList"][i];
            var entry = visConf["CountryInfo"][alpha3];
            if (typeof(entry) === "undefined")
                continue;

            var opt = document.createElement("option");
            opt.text = entry["name"];
            opt.value = entry["id"];
            this.selCntry.add(opt, null);
        }
    };

    page.initRangeMonth = function () {
        var rngMonth = this.rngMonth;
        rngMonth.min = 0;
        rngMonth.max = visConf.MonthList.length - 1;

        // Set default state
        rngMonth.value = rngMonth.max;
        this.lbMonth.textContent = visConf.MonthList[rngMonth.max];

        // Register event handler
        rngMonth.onchange = function () {
            var i = parseInt(this.value);

            page.lbMonth.textContent = visConf.MonthList[i];

            // Update map
            page.mapWnd.repaint();
        };

        rngMonth.oninput = function () {
            var i = parseInt(this.value);

            page.lbMonth.textContent = visConf.MonthList[i];

            // Update map
            page.mapWnd.repaint();
        };
    };

    page.initAlphaBeta = function () {
        // Some config
        var rngMax = 5000;
        var step = (0.0 + visConf["AbMax"]) / rngMax;
        var iniValue = Math.round(1.0 / step);

        this.rngAlpha.min = 0;
        this.rngAlpha.max = rngMax;
        this.rngAlpha.value = iniValue;
        // this.rngAlpha.onclick = this.onAlphaChange;
        this.rngAlpha.oninput = this.onAlphaChange;

        this.nbAlpha.step = 0.1
        this.nbAlpha.min = 0;
        this.nbAlpha.max = visConf["AbMax"];
        this.nbAlpha.value = 1;
        // this.nbAlpha.onchange = this.onNbAlphaChange;
        this.nbAlpha.oninput = this.onNbAlphaChange;

        this.rngBeta.min = 0;
        this.rngBeta.max = rngMax;
        this.rngBeta.value = iniValue;
        // this.rngBeta.onclick = this.onBetaChange;
        this.rngBeta.oninput = this.onBetaChange;

        this.nbBeta.step = 0.1
        this.nbBeta.min = 0;
        this.nbBeta.max = visConf["AbMax"];
        this.nbBeta.value = 1;
        // this.nbBeta.onchange = this.onNbBetaChange;
        this.nbBeta.oninput = this.onNbBetaChange;
    };

    page.initRho = function () {
        var step = 1;

        this.rngRho.min = 1;
        this.rngRho.max = visConf["RhoMax"];
        this.rngRho.step = step;
        this.rngRho.oninput = this.onRhoChange;

        this.nbRho.min = 1;
        this.nbRho.max = visConf["RhoMax"];
        this.nbRho.step = step;
        this.nbRho.oninput = this.onNbRhoChange;

        this.rngRho.value = visConf["rho"];
        this.nbRho.value = visConf["rho"];
    };

    page.initLegendBar = function () {
        var colors = visConf.ColorMap;

        var params = "";
        for(var i = 4; i < colors.length; i += 2) {
            params += ", " + colors[i];
        }

        var legend = document.getElementById("legend");
        legend.style.backgroundImage = "linear-gradient(90deg" + params + ")";
    };

    page.createMap = function () {
        this.mapWnd = new MapWindow(this);
        this.mapWnd.createMap();
    };

    page.init = function () {
        this.initSelCountry();
        this.initLegendBar();
        this.initRangeMonth();
        this.initAlphaBeta();
        this.initRho();

        var toWorld = document.getElementById("bnToWorld");
        toWorld.onclick = this.onToWorld;

        this.rdDivn.onclick = this.onChooseDivision;
        this.rdDivn.checked = true;

        this.rdGrid.onclick = this.onChooseGrid;

        this.selCntry.onchange = this.onCountryChanged;
        this.detailSetup.onchange = this.onDetailSetupChanged;

        this.bOnPlay = false;
        this.bnPlay.onclick = this.onPlayButtonClicked;

        this.createMap();
    };

    // UI Actions --------------------------
    page.updateInfoBoard = function (name, popu, bs, imba) {
        this.infoName.textContent = name;
        this.infoPopu.textContent = popu;
        this.infoBstn.textContent = bs;

        if (imba == -1) {
            this.infoImba.textContent = "Empty";
        } else {
            var content = "" + imba;
            var i = content.indexOf(".");
            this.infoImba.textContent = content.slice(0, i+5);
        }

        this.infoBoard.style.display = "block";
    };

    page.synchroSelCountry = function (alpha3) {
        var i = 0;
        for (i = 0; i < this.selCntry.options.length; i++) {
            var opt = this.selCntry.options[i];
            if (opt.value == alpha3) {
                this.selCntry.selectedIndex = i;
                return;
            }
        }

        this.selCntry.selectedIndex = 0;
    }

    page.stopAnimation = function () {
        page.bnPlay.className = "fas fa-play";
        page.bOnPlay = false;
    };

    // Event Handlers ----------------------
    page.onAlphaChange = function () {
        var step = (0.0 + visConf["AbMax"]) / page.rngAlpha.max;
        visConf["alpha"] = page.rngAlpha.value * step;

        var nbAlpha = page.nbAlpha;
        var content = "" + visConf["alpha"];
        var i = content.indexOf(".");
        content = content.slice(0, i+4);
        nbAlpha.value = parseFloat(content);

        page.mapWnd.repaint();
    };

    page.onBetaChange = function () {
        var step = (0.0 + visConf["AbMax"]) / page.rngBeta.max;
        visConf["beta"] = page.rngBeta.value * step;

        var nbBeta = page.nbBeta;
        var content = "" + visConf["beta"];
        var i = content.indexOf(".");
        content = content.slice(0, i+4);
        nbBeta.value = parseFloat(content);

        page.mapWnd.repaint();
    };

    page.onNbAlphaChange = function () {
        var value = page.nbAlpha.value;
        visConf["alpha"] = value;

        var i = parseInt(value*1000);
        page.rngAlpha.value = i;

        page.mapWnd.repaint();
    };

    page.onNbBetaChange = function () {
        var value = page.nbBeta.value;
        visConf["beta"] = value;

        var i = parseInt(value*1000);
        page.rngBeta.value = i;

        page.mapWnd.repaint();
    };

    page.onRhoChange = function () {
        visConf["rho"] = page.rngRho.value;
        page.nbRho.value = visConf["rho"];

        page.mapWnd.repaint();
    };

    page.onNbRhoChange = function () {
        visConf["rho"] = page.nbRho.value;
        page.rngRho.value = visConf["rho"];

        page.mapWnd.repaint();
    };

    page.onToWorld = function () {
        if (page.mapWnd.scenario.sourceId == "World") {
            page.mapWnd.map.setCenter([0, 0]);
            page.mapWnd.map.setZoom(2);
            return;
        }

        page.showDefaultScenario();        
    };

    page.onChooseDivision = function () {
        var selIndex = page.selCntry.selectedIndex;

        if (selIndex == 0) {
            return;
        }

        var opt = page.selCntry.options[selIndex];
        var alpha3 = opt.value;

        visPage.showCountryDivn(alpha3, 1);
        visPage.tryLoadDivisionSetup();
    };

    page.onChooseGrid = function () {
        page.loadGridSetup();
        // Try to show directly
        // var iSelC = page.selCntry.selectedIndex;

        // if (iSelC > 0) {
        //     var alpha3 = page.selCntry.options[iSelC].value;

        //     var iSelGrid = page.detailSetup.selectedIndex;
        //     if (iSelGrid > 0) {
        //         var setName = page.detailSetup.options[iSelGrid].value;
        //         visPage.showCountryGrid(alpha3, setName);
        //     }
        // }
    };

    page.onCountryChanged = function () {
        // Switch to the selected country and show
        var selIndex = page.selCntry.selectedIndex;

        if (selIndex == 0) {
            if (page.mapWnd.currentAlpha3() != "World") {
                page.showDefaultScenario();
            }

            return;
        }

        var opt = page.selCntry.options[selIndex];
        var alpha3 = opt.value;
        if (alpha3 != page.mapWnd.currentAlpha3()) {
            if (page.rdDivn.checked == true) {
                visPage.showCountryDivn(alpha3, 1);
                page.tryLoadDivisionSetup();
            } else {
                page.loadGridSetup();
            }
        }
    };

    page.onDetailSetupChanged = function () {
        var iSelC = page.selCntry.selectedIndex;

        if (iSelC > 0) {
            var alpha3 = page.selCntry.options[iSelC].value;

            var iSel = this.selectedIndex;
            
            if (page.rdDivn.checked == true) {
                visPage.showCountryDivn(alpha3, iSel+1);
            } else {
                var setName = this.options[iSel].value;
                visPage.showCountryGrid(alpha3, setName);
            }
        }
    };

    page.onPlayButtonClicked = function () {
        if (page.bOnPlay) {
            page.stopAnimation();
        } else {
            page.bOnPlay = true;
            PlayAnimation();
        }
    };

    // Visualization -----------------------
    page.loadWorld = function () {
        var geoUrl = "VisData/Level1Shape/World.geojson";
        var imbaUrl = "VisData/Level1Imba/World.json";

        var fc = LoadJsonFile(geoUrl);
        if (typeof(fc) === "undefined" ) {
            return;
        }

        var imbaDict = LoadJsonFile(imbaUrl);
        if (typeof(imbaDict) === "undefined" ) {
            return;
        }

        var sc = Scenario(fc, imbaDict);
        sc.sourceId = "World";
        sc.alpha3 = "World";
        sc.updateImbaIndex(this.getMonthIndex());

        this.scWorld = sc;
    };

    page.showDefaultScenario = function () {
        if (this.scWorld == null) {
            this.loadWorld();
        }

        this.mapWnd.replaceScenario(this.scWorld);
        this.mapWnd.map.setCenter([0, 0]);
        this.mapWnd.map.setZoom(2);

        this.selCntry.selectedIndex = 0;
        this.rdDivn.checked = true;
        this.rdGrid.disabled = true;
        this.detailSetup.disabled = true;
    };

    page.showCountryDivn = function (alpha3, iLvl) {
        var geoUrl = "VisData/Level" + iLvl + "Shape/" + alpha3 + ".geojson";
        var imbaUrl = "VisData/Level" + iLvl + "Imba/" + alpha3 + ".json";

        var fc = LoadJsonFile(geoUrl);
        if (typeof(fc) === "undefined" ) {
            return;
        }

        var imbaDict = LoadJsonFile(imbaUrl);
        if (typeof(imbaDict) === "undefined" ) {
            return;
        }
        
        this.rdGrid.disabled = false;
        this.detailSetup.disabled = false;

        var sc = Scenario(fc, imbaDict);
        sc.sourceId = alpha3 + "-D" + iLvl;
        sc.alpha3 = alpha3;
        sc.updateImbaIndex(this.getMonthIndex());

        this.mapWnd.replaceScenario(sc);
        this.flyTo(alpha3);
    };

    page.showCountryGrid = function (alpha3, setName) {
        var geoUrl = "VisData/ImbaGrid/Shape/" + alpha3 + "/" + setName + ".geojson";
        var imbaUrl = "VisData/ImbaGrid/ImbaIndex/" + alpha3 + "/" + setName + ".json";

        var fc = LoadJsonFile(geoUrl);
        if (typeof(fc) === "undefined" ) {
            return;
        }

        var imbaDict = LoadJsonFile(imbaUrl);
        if (typeof(imbaDict) === "undefined" ) {
            return;
        }

        this.rdGrid.disabled = false;
        this.detailSetup.disabled = false;
        
        var sc = Scenario(fc, imbaDict);
        sc.sourceId = alpha3 + setName;
        sc.alpha3 = alpha3;
        sc.Opacity = visConf.GridOpacity;
        sc.updateImbaIndex(this.getMonthIndex());

        this.mapWnd.replaceScenario(sc);
        this.flyTo(alpha3);
    };

    page.flyTo = function (alpha3) {
        var feats = this.scWorld.feats["features"];

        var feature = null;
        for (var i = 0; i < feats.length; i++) {
            if (feats[i]["id"] == alpha3) {
                feature = feats[i];
            }
        }

        if (feature != null) {
            var bnds = feature["properties"]["b"];

            this.mapWnd.map.fitBounds(bnds, {
                padding: 150
            });
        }
    };

    page.focusOn = function (alpha3) {

    };

    page.tryLoadDivisionSetup = function () {
        this.detailSetup.options.length = 0;
        var iSel = this.selCntry.selectedIndex;
        var alpha3 = this.selCntry.options[iSel].value;

        var iTotal = visConf["CountryInfo"][alpha3]["bDivn"];
        for (var i = 0; i < iTotal; i++) {
            var opt = document.createElement("option");
            opt.text = "Level " + (i+1);
            opt.value = i;
            detailSetup.add(opt, null);
        }

        detailSetup.selectedIndex = 0;
    };

    page.tryLoadGridSetup = function () {
        this.detailSetup.options.length = 0;

        // var opt = document.createElement("option");
        // opt.text = "Select...";
        // opt.value = 0;
        // detailSetup.add(opt, null);
        // detailSetup.selectedIndex = 0;
        // detailSetup.disabled = true;

        var iSel = this.selCntry.selectedIndex;

        if (iSel == 0) {
            return;
        }

        // Load Json Config
        var alpha3 = this.selCntry.options[iSel].value;
        var url = "VisData/ImbaGrid/Config/" + alpha3 + ".json";

        // Request the JSON file
        var request = new XMLHttpRequest();
        request.open("get", url);

        var jsonData = null;
        request.onload = function () {
            // If code is 200, we succeed
            if (request.status == 200) {
                jsonData = JSON.parse(request.responseText);

                var setups = jsonData["Setup"];
                var sizes = jsonData["Size"]
                if (setups.length > 0) {
                    var detailSetup = document.getElementById("detailSetup");

                    var texts = ["Large (", "Medium (", "Small ("]
                    for (var i = 0; i < setups.length; i++) {
                        var opt = document.createElement("option");
                        opt.text = texts[i] + sizes[i] + "km)";
                        opt.value = setups[i];
                        detailSetup.add(opt, null);
                    }

                    // Show first one
                    // detailSetup.selectedIndex = 0;
                    // var setName = detailSetup.options[0].value;
                    // page.showCountryGrid();
                }
            }
        }

        request.send(null);
    };

    page.loadGridSetup = function () {
        this.detailSetup.options.length = 0;

        var iSel = this.selCntry.selectedIndex;

        if (iSel == 0) {
            return;
        }

        // Load Json Config
        var alpha3 = this.selCntry.options[iSel].value;
        var url = "VisData/ImbaGrid/Config/" + alpha3 + ".json";
        var jsonData = LoadJsonFile(url);

        if (typeof(jsonData) === "undefined") {
            return;
        }

        var setups = jsonData["Setup"];
        var sizes = jsonData["Size"]
        if (setups.length > 0) {
            var detailSetup = page.detailSetup;

            var texts = ["Large (", "Medium (", "Small ("]
            for (var i = 0; i < setups.length; i++) {
                var opt = document.createElement("option");
                opt.text = texts[i] + sizes[i] + "km)";
                opt.value = setups[i];
                detailSetup.add(opt, null);
            }

            // Show first one
            detailSetup.selectedIndex = 0;
            var setName = detailSetup.options[0].value;
            page.showCountryGrid(alpha3, setName);
        }
    };

    // Helpers ---------------------------------------
    page.getMonthIndex = function () {
        return this.rngMonth.value;
    };

    page.getMonthText = function () {
        var i = this.rngMonth.value;
        return visConf.MonthList[i];
    };

    return page;
}

// Mapbox map
function MapWindow (parent) {
    var mapWnd = new Object();
    mapWnd.parent = parent;       // the master visPage object

    mapWnd.map = null;
    mapWnd.scenario = null;

    mapWnd.createMap = function () {
        this.map = new mgl.Map({
            container: 'map',
            style: visConf.MapBoxStyle,
            center: [0, 0],
            zoom: 2
        });
    };

    mapWnd.replaceScenario = function (sc) {
        var old = null;
        if (this.scenario != null) {
            var id = this.scenario.getOutlineLayerId();
            this.map.removeLayer(id);
            id = this.scenario.getFillLayerId();
            this.map.removeLayer(id);
            id = this.scenario.sourceId;
            this.map.removeSource(id);
            old = this.scenario;
        }

        this.map.addSource(sc.sourceId, sc.source);
        this.map.addLayer(sc.getFillLayer(), 'waterway-label');
        this.map.addLayer(sc.getOutlineLayer(), 'waterway-label');

        this.scenario = sc;
        this.registerEvents();
        return old;
    };

    mapWnd.repaint = function () {
        var sc = this.scenario;
        sc.updateImbaIndex(this.parent.getMonthIndex());

        var source = this.map.getSource(sc.sourceId);
        source.setData(sc.feats);
    };

    mapWnd.currentAlpha3 = function () {
        return this.scenario.alpha3;
    };

    mapWnd.onMouseMove = function (e) {
        if (e.features.length == 0) {
            return;
        }

        var feature = e.features[0];
        var id = feature["properties"]["mb"];
        if (typeof(id) === "undefined") {
            return;
        }

        // Fetch data from Scenario by id
        var data = mapWnd.scenario.getFeatureData(id);
        if (typeof(data) === "undefined") {
            return;
        }

        var name = feature["properties"]["name"];
        var popu = data[0];
        var bs = data[1];
        var imba = feature["properties"]["i"];

        visPage.updateInfoBoard(name, popu, bs, imba);
    };

    mapWnd.onMouseClick = function (e) {
        if (e.features.length == 0) {
            return;
        }

        var feature = e.features[0];
        var id = feature["properties"]["mb"];
        if (typeof(id) === "undefined") {
            return;
        }

        visPage.synchroSelCountry(id);
        visPage.showCountryDivn(id, 1);
        visPage.tryLoadDivisionSetup();
    };

    mapWnd.registerEvents = function () {
        // Remove old listeners first
        this.map.off('mousemove', this.onMouseMove);
        this.map.off('click', this.onMouseClick);

        // Add new listener
        var id = this.scenario.getFillLayerId();
        this.map.on('mousemove', id, this.onMouseMove);

        // When display world map, add click event
        if (this.scenario.alpha3 == "World") {
            this.map.on("click", id, this.onMouseClick);
        }
    };

    return mapWnd;
}

// A map scenario with data and layers
function Scenario(fc, imbaDict) {
    var sc = new Object();

    sc.feats = fc;
    sc.imbaDict = imbaDict;

    sc.sourceId = null;
    sc.source = {
        'type': 'geojson',
        'data': sc.feats
    };

    sc.alpha3 = null;
    sc.Opacity = visConf.Opacity;

    sc.getFillLayer = function () {
        return {
            'id': sc.getFillLayerId(),
            'type': 'fill',
            'source': sc.sourceId,
            'layout': {},
            'paint': {
                'fill-color': visConf.FillColorSetup,
                'fill-opacity': this.Opacity
            }
        };
    };

    sc.getOutlineLayer = function () {
        return {
            'id': sc.getOutlineLayerId(),
            'type': 'line',
            'source': sc.sourceId,
            'layout': {},
            'paint': {
                'line-color': visConf.OutlineColor,
                'line-width': 1
            }
        };
    };

    sc.getFillLayerId = function () {
        return sc.sourceId + "-F";
    };

    sc.getOutlineLayerId = function () {
        return sc.sourceId + "-O";
    };

    sc.updateImbaIndex = function (iMonth) {
        var featList = this.feats["features"];
        for (var i = 0; i < featList.length; i++) {
            var feature = featList[i];
            var id = feature["id"];

            // Get Population and BaseStation
            var entry = this.imbaDict[id];
            if (typeof(entry) === "undefined") {
                feature["properties"]["i"] = -1;
            } else {
                if (entry["b"] == 0) {
                    feature["properties"]["i"] = 0;
                } else {
                    var popu = entry["p"];
                    var bs = entry["b"][iMonth];
    
                    feature["properties"]["i"] = ImbaIndex(popu, bs);
                }                
            }
        }
    };

    sc.getFeatureData = function (id) {
        var iMonth = visPage.getMonthIndex();
        var entry = this.imbaDict[id];
        if (typeof(entry) === "undefined") {
            return entry;
        }

        if (entry["b"] == 0) {
            return [0, 0];
        }

        return [entry["p"], entry["b"][iMonth]];
    };

    return sc;
}

// --------------- Common Functions -----------------

function ImbaIndex(pop, bs) {
    if (bs == pop && bs ==0)
        return 0;

    if (pop <= visConf["rho"] * bs)
        return 0;

    if (bs == 0)
        return 1;

    var revised_bs = visConf["rho"] * bs;

    var a = visConf["alpha"];
    var b = visConf["beta"];

    var p_b = pop / revised_bs;
    var log_p_b = Math.log(p_b);
    var a_exp_b = a * Math.pow(log_p_b, b);
    var exp_a = 1. + Math.exp(-a_exp_b);
    var inverse = 1.0 / exp_a;
    var imbaIndex = 2 * inverse - 1;

    return imbaIndex;
}

// ======================================

function DebugShowInfo (text) {
    var oDiv = document.getElementById("infodiv");
    oDiv.innerHTML = text;
}
